// Data and Config
import jwt from "jsonwebtoken";
import Axios from "axios";
import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch, getTokenAsync } from "../../config/azureConfig";

// Other
import {
  CREATE_ROLE,
  DELETE_ROLE,
  GET_ROLES,
  GET_ROLE,
  UPDATE_ROLE,
  GET_ROLES_FOR_USER,
  GET_ROLES_FOR_LOGGED_IN_USER,
  ASSIGN_USERS_TO_ROLE,
  REMOVE_USERS_FROM_ROLE
} from "../constants/action-types";
import { UserRoles } from "../../state/constants/UserRoles";

const API_CONFIG = getApiConfig();

/* 
    Get a list of roles.
*/
export const getRoles = (callback) => async (dispatch) => {
  try {
    const response = await adalApiFetch(
      Axios, `${API_CONFIG.ROLES}/GetRoles`,
      {
        method: "get"
      }
    );

    dispatch({
      type: GET_ROLES,
      payload: response.data
    });

    callback(true);
  } catch (error) {
    console.log(error);
    callback(false);
  }
};

/* 
    Get a role.
*/

export const getRole = (roleId, callback) => async (dispatch) => {
  try {
    const response = await adalApiFetch(
      Axios, `${API_CONFIG.ROLES}/GetRole/?roleId=${roleId}`,
      {
        method: "get"
      }
    );

    dispatch({
      type: GET_ROLE,
      payload: response.data
    });

    callback(true);
  } catch (error) {
    console.log(error);
    callback(false);
  }
};

/*
    Create a new role
*/
export const createRole = (role, callback) => {
  return async (dispatch) => {
    const headers = { "Content-Type": "application/json" };

    const data = {
      RoleName: role.name,
      Description: role.description
    };

    try {
      await adalApiFetch(Axios, `${API_CONFIG.ROLES}/CreateRole`,
        {
          method: "post",
          data: data,
          headers: headers
        });

      dispatch({
        type: CREATE_ROLE,
        payload: role
      });

      callback(true);
    } catch (error) {
      console.log(`Exception occured: ${error.message}`);
      callback(false);
    }
  };
};

/*
    Update a role
*/
export const updateRole = (roleId, role, callback) => {
  return async (dispatch) => {
    const headers = { "Content-Type": "application/json" };

    const data = {
      RoleName: role.name,
      Description: role.description
    };

    try {
      await adalApiFetch(
        Axios, `${API_CONFIG.ROLES}/UpdateRole?roleId=${roleId}`,
        {
          method: "post",
          data: data,
          headers: headers
        }
      );

      dispatch({
        type: UPDATE_ROLE,
        payload: role
      });

      callback(true);
    } catch (error) {
      console.log(`Exception occurred: ${error.message}`);
      callback(false);
    }
  };
};

/*
    Update role locally only
*/
export const updateRoleLocally = (role) => (dispatch) => {
  dispatch({
    type: UPDATE_ROLE,
    payload: role
  });
};

/*
    Delete a role
*/
export const deleteRole = (roleId, callback) => {
  return async (dispatch) => {
    const headers = { "Content-Type": "application/json" };

    try {
      await adalApiFetch(
        Axios, `${API_CONFIG.ROLES}/DeleteRole?roleId=${roleId}`,
        {
          method: "delete",
          headers: headers
        }
      );

      dispatch({
        type: DELETE_ROLE
      });

      callback(true);
    } catch (error) {
      console.log(`Exception occurred: ${error.message}`);
      callback(false);
    }
  };
};

/* 
    Get a list of roles for a specific user.
*/
export const getRolesForUser = (userId, callback) => (dispatch) => {
  adalApiFetch(
    Axios, `${API_CONFIG.ROLES}/GetRolesForUser?userID=${userId}`,
    {
      method: "get"
    }
  )
    .then((res) => {
      dispatch({
        type: GET_ROLES_FOR_USER,
        payload: res.data
      });

      callback(true);
    })
    .catch((error) => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    });
};

/*
    Get a list of the roles that the logged in user belongs to so they can only access the areas they have permissions to view
*/
export const getRolesForLoggedInUser = (callback) => (dispatch) => {
  const {
    SAM_CORE_ADMIN,
    USER_MANAGER,
    CONTENT_MANAGER,
    CONTENT_ADMIN,
    CONTENT_TARGETING_MANAGER,
    ACTIVITY_MANAGER,
    MYCCA_CONTENT_ADMIN,
    CORE_RANGE_ADMIN,
    CORE_RANGE_USER,
    MY_DISPLAYS_ADMIN,
    SEC_ADMIN,
    NEW_LEADS_ADMIN,
    SAMA_ADMIN,
    WHERE_IS_MY_DELIVERY,
    RRC_EDIT_INVENTORY,
    RRC_VIEW
  } = UserRoles;

  getTokenAsync((errorDesc, token, error) => {
    const decodedToken = jwt.decode(token);

    let roles = [];

    if (decodedToken) {
      let userEmail;
      if (decodedToken.tid == "c3549632-51ee-40fe-b6ae-a69f3a6cc157") {
        userEmail = decodedToken.extensionattribute10;
      } else {
        userEmail = decodedToken.upn ?? decodedToken.unique_name;
      }
      const userName = `ausdom\\${userEmail}`;

      // Get the logged in users roles from SaM core
      adalApiFetch(
        Axios, `${API_CONFIG.ROLES}/GetRolesForUsername?Username=${userName}`,
        {
          method: "get"
        }
      )
        .then((res) => {
          roles = res.data.map((role) => {
            const roleName = role.RoleName.substring(
              role.RoleName.indexOf("\\") + 1
            );

            // FIXME: delete this function
            switch (roleName) {
              case SAM_CORE_ADMIN:
                return SAM_CORE_ADMIN;
              case USER_MANAGER:
                return USER_MANAGER;
              case CONTENT_MANAGER:
                return CONTENT_MANAGER;
              case CONTENT_ADMIN:
                return CONTENT_ADMIN;
              case CONTENT_TARGETING_MANAGER:
                return CONTENT_TARGETING_MANAGER;
              case ACTIVITY_MANAGER:
                return ACTIVITY_MANAGER;
              case MYCCA_CONTENT_ADMIN:
                return MYCCA_CONTENT_ADMIN;
              case CORE_RANGE_ADMIN:
                return CORE_RANGE_ADMIN
              case CORE_RANGE_USER:
                return CORE_RANGE_USER
              case MY_DISPLAYS_ADMIN:
                return MY_DISPLAYS_ADMIN
              case SEC_ADMIN:
                return SEC_ADMIN
              case NEW_LEADS_ADMIN:
                return NEW_LEADS_ADMIN
              case SAMA_ADMIN:
                return SAMA_ADMIN
              case WHERE_IS_MY_DELIVERY:
                return WHERE_IS_MY_DELIVERY
              case RRC_EDIT_INVENTORY:
                return RRC_EDIT_INVENTORY
              case RRC_VIEW:
                return RRC_VIEW
              default:
                return null;
            }
          });

          dispatch({
            type: GET_ROLES_FOR_LOGGED_IN_USER,
            payload: roles.filter((role) => role !== null)
          });

          callback(true);
        })
        .catch((error) => {
          console.log(`Exception Occurred: ${error}`);
          if (callback) {
            callback(false);
          }
        });
    } else {
      callback(false);
    }
  });
};

/* 
    Assign users to a role.
*/
export const assignUsersToRole = (userIds, roleId, callback) => (dispatch) => {
  adalApiFetch(
    Axios, `${API_CONFIG.ROLES}/AssignUsersToRole?roleId=${roleId}`,
    {
      method: "post",
      data: userIds
    }
  )
    .then((_) => {
      dispatch({
        type: ASSIGN_USERS_TO_ROLE,
        payload: { userIds, roleId }
      });

      callback(true);
    })
    .catch((error) => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    });
};

/*
    Remove users from role(s)
*/
export const removeUsersFromRole = (userIds, roleId, callback) => (
  dispatch
) => {
  adalApiFetch(
    Axios, `${API_CONFIG.ROLES}/RemoveUsersFromRole?roleId=${roleId}`,
    {
      method: "delete",
      data: userIds
    }
  )
    .then((_) => {
      dispatch({
        type: REMOVE_USERS_FROM_ROLE,
        payload: { userIds, roleId }
      });

      callback(true);
    })
    .catch((error) => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    });
};
